import moment from 'moment';
import { UploadOutlined } from '@ant-design/icons';
import {
  Button,
  Col,
  DatePicker,
  Form,
  InputNumber,
  Row,
  Select,
  Space,
  Upload,
} from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import { useEffect, useState } from 'react';
import { VendorType } from '../../modules/vendors';
import styled from 'styled-components';

const { Option } = Select;

const StyledDiv = styled.div`
  .ant-select-selector {
    white-space: pre-wrap;
    height: fit-content !important;
  }

  .ant-select-selection-item {
    white-space: pre-wrap;
  }

  .ant-select-item-option-content {
    white-space: pre-wrap;
  }
`;

interface InvoiceCreateUpdateComponentProps {
  invoice?: any;
  invoiceCommon: any;
  uploadProps: any;
  onCreate: (data: any) => void;
  onCancel: () => void;
}

function InvoiceCreateUpdateComponent({
  invoice,
  invoiceCommon,
  uploadProps,
  onCreate,
  onCancel,
}: InvoiceCreateUpdateComponentProps) {
  const [form] = Form.useForm();
  const [mount, setMount] = useState(true);
  // const [projectList, setProjectList] = useState<any[]>();
  const [vendorCompanyList, setVendorCompanyList] = useState<any[]>();
  const [vendorWorkerList, setVendorWorkerList] = useState<any[]>();
  const [categoryList, setCategoryList] = useState<any[]>();
  const [gongjongList, setGongjongList] = useState<any[]>();
  const [approvalConfig, setApprovalConfig] = useState<any[]>();
  let _invoice: any;

  useEffect(() => {
    if (!mount) return;
    let children: any = [];

    for (const vendor of invoiceCommon.vendorList
      .filter((vendor: any) => vendor.type === VendorType.COMPANY)
      .sort((a: any, b: any) => a.name.localeCompare(b.name))) {
      children.push(
        <Option key={vendor.id} value={vendor.id}>
          {vendor.name} / {vendor.info}
        </Option>,
      );
    }
    setVendorCompanyList(children);

    children = [];
    for (const vendor of invoiceCommon.vendorList
      .filter((vendor: any) => vendor.type === VendorType.WORKER)
      .sort((a: any, b: any) => a.name.localeCompare(b.name))) {
      children.push(
        <Option key={vendor.id} value={vendor.id}>
          {vendor.name} / {vendor.info}
        </Option>,
      );
    }
    setVendorWorkerList(children);

    children = [];
    for (const category of invoiceCommon.categoryList.sort((a: any, b: any) =>
      a.name.localeCompare(b.name),
    )) {
      children.push(
        <Option key={category.id} value={category.name}>
          {category.name}
        </Option>,
      );
    }
    setCategoryList(children);

    children = [];
    for (const approvalConfig of invoiceCommon.approvalConfig.sort(
      (a: any, b: any) => a.name.localeCompare(b.name),
    )) {
      children.push(
        <Option key={approvalConfig.value} value={approvalConfig.value}>
          {approvalConfig.name}
        </Option>,
      );
    }
    setApprovalConfig(children);

    // children = [];
    // children.push(
    //   <Option key={null} value={''}>
    //     {'선택 안함'}
    //   </Option>,
    // );
    // for (const project of invoiceCommon.projectList) {
    //   children.push(
    //     <Option key={project.id} value={project.id}>
    //       {project.name} ({project.startDate} ~ {project.endDate})
    //     </Option>,
    //   );
    // }
    // setProjectList(children);

    children = [];
    for (const gongjong of invoiceCommon.gongjongList.sort((a: any, b: any) =>
      a.name.localeCompare(b.name),
    )) {
      children.push(
        <Option key={gongjong.id} value={gongjong.name}>
          {gongjong.name}
        </Option>,
      );
    }
    setGongjongList(children);

    return () => setMount(false);
  }, [invoiceCommon, mount]);

  if (!!invoice) {
    _invoice = {
      ...invoice,
      supplyPrice: invoice.price - invoice.vat,
      billingDate: moment(invoice.billingDate, 'YYYY-MM-DD'),
      approvalConfig: invoice.approvalConfig.name,
    };
  } else {
    _invoice = {
      vendor: {
        type: VendorType.COMPANY,
      },
      isCreditTransaction: false,
      approvalConfig:
        invoiceCommon.approvalConfig.length > 0
          ? invoiceCommon.approvalConfig[0].value
          : '',
    };
  }

  const normFile = (e: any) => {
    let fileList = e.fileList;
    if (Array.isArray(e)) {
      return e;
    }
    return e && fileList;
  };

  const updatePriceField = () => {
    const price = form.getFieldValue('price');
    const supplyPrice =
      form.getFieldValue(['vendor', 'type']) === VendorType.COMPANY
        ? Math.round(price / 1.1)
        : price;
    const vat = price - supplyPrice;
    // console.log(price);
    // console.log(supplyPrice);
    // console.log(vat);
    form.setFieldsValue({
      vat,
      price,
      supplyPrice,
    });
  };

  const updateSupplyPriceField = () => {
    const supplyPrice = form.getFieldValue('supplyPrice');
    const vat =
      form.getFieldValue(['vendor', 'type']) === VendorType.COMPANY
        ? Math.round(supplyPrice * 0.1)
        : 0;
    const price = supplyPrice + vat;

    // console.log(price);
    // console.log(supplyPrice);
    // console.log(vat);
    form.setFieldsValue({
      vat,
      price,
      supplyPrice,
    });
  };

  const updateVatField = () => {
    const price = form.getFieldValue('price');
    const vat = form.getFieldValue('vat');
    const supplyPrice = price - vat;
    form.setFieldsValue({
      vat,
      price,
      supplyPrice,
    });
  };

  return (
    <StyledDiv>
      <Form
        form={form}
        layout="vertical"
        onFinish={onCreate}
        initialValues={_invoice}
      >
        <Row>
          <Col span={24}>
            <Form.Item
              name={['vendor', 'type']}
              label="거래처 구분"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Select
                allowClear
                style={{ width: '100%' }}
                placeholder="거래처 구분을 입력하세요"
                onChange={(type: string) => {
                  form.setFieldsValue({
                    vendor: {
                      type,
                      id: undefined,
                    },
                  });
                }}
              >
                <Option value="1">사업자</Option>
                <Option value="2">작업자(부가세 제외)</Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Form.Item
              noStyle
              shouldUpdate={(prevValues, currentValues) =>
                prevValues.vendor.type !== currentValues.vendor.type
              }
            >
              {({ getFieldValue }) => (
                <Form.Item
                  name={['vendor', 'id']}
                  label="거래처 이름"
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <Select
                    style={{ width: '100%' }}
                    placeholder="거래처 이름을 선택 하세요."
                    showSearch
                    optionFilterProp="children"
                    filterOption={(input: string, option: any) => {
                      // console.log(option);
                      return (
                        option.children.filter((child: any) => {
                          // console.log(child);
                          // console.log(input.trim());
                          return child.includes(input.trim());
                        }).length > 0
                      );
                    }}
                  >
                    {getFieldValue(['vendor', 'type']) === VendorType.COMPANY
                      ? vendorCompanyList
                      : vendorWorkerList}
                  </Select>
                </Form.Item>
              )}
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Form.Item
              name="price"
              label="합계 금액(환불 시 마이너스 금액 입력)"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <InputNumber
                style={{ width: '100%' }}
                formatter={(value) =>
                  `₩ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                }
                parser={(value) => value!.replace(/₩\s?|(,*)/g, '')}
                onChange={updatePriceField}
              />
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col span={24}>
            <Form.Item
              name="supplyPrice"
              label="공급가액(환불 시 마이너스 금액 입력)"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <InputNumber
                style={{ width: '100%' }}
                formatter={(value) =>
                  `₩ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                }
                parser={(value) => value!.replace(/₩\s?|(,*)/g, '')}
                onChange={updateSupplyPriceField}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Form.Item
              noStyle
              shouldUpdate={(prevValues, currentValues) =>
                prevValues.vendor.type !== currentValues.vendor.type
              }
            >
              {({ getFieldValue }) => (
                <Form.Item
                  name="vat"
                  label="부가세(환불 시 마이너스 금액 입력)"
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <InputNumber
                    style={{ width: '100%' }}
                    formatter={(value) =>
                      `₩ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                    }
                    parser={(value) => value!.replace(/₩\s?|(,*)/g, '')}
                    onChange={updateVatField}
                    disabled={
                      getFieldValue(['vendor', 'type']) === VendorType.WORKER
                    }
                  />
                </Form.Item>
              )}
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Form.Item
              name="billingDate"
              label="청구일시"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <DatePicker format="YYYY-MM-DD" style={{ width: '100%' }} />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Form.Item name="gongjong" label="공사종류">
              <Select style={{ width: '100%' }} allowClear>
                {gongjongList}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Form.Item
              name="category"
              label="용도"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Select style={{ width: '100%' }}>{categoryList}</Select>
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Form.Item
              name="approvalConfig"
              label="전자결재"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Select style={{ width: '100%' }}>{approvalConfig}</Select>
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Form.Item
              name="isCreditTransaction"
              label="외상거래"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Select style={{ width: '100%' }}>
                <Option value={true}>예</Option>
                <Option value={false}>아니오</Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Form.Item name="description" label="설명">
              <TextArea rows={4} />
            </Form.Item>
          </Col>
        </Row>
        {/* <Row>
          <Col span={24}>
            <Form.Item name={['project', 'id']} label="프로젝트">
              <Select style={{ width: '100%' }}>{projectList}</Select>
            </Form.Item>
          </Col>
        </Row> */}
        <Row>
          <Col span={24}>
            <Form.Item
              name="file"
              label="첨부파일"
              valuePropName="fileList"
              getValueFromEvent={normFile}
            >
              <Upload {...uploadProps}>
                <Button icon={<UploadOutlined rev={undefined} />}>
                  파일 올리기
                </Button>
              </Upload>
            </Form.Item>
          </Col>
        </Row>

        <Row justify="center">
          <Form.Item>
            <Space size="middle">
              <Button htmlType="button" onClick={onCancel}>
                취소
              </Button>
              <Button
                type="primary"
                htmlType="submit"
                style={{ width: '100px' }}
              >
                확인
              </Button>
            </Space>
          </Form.Item>
        </Row>
      </Form>
    </StyledDiv>
  );
}
export default InvoiceCreateUpdateComponent;
